import { render, staticRenderFns } from "./PetsClaimCustomer.vue?vue&type=template&id=ff93b292&"
import script from "./PetsClaimCustomer.vue?vue&type=script&lang=js&"
export * from "./PetsClaimCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports